import { Link, createFileRoute } from '@tanstack/react-router'
import { locationApi } from '../../features/locations/services/locationApi'

export const Route = createFileRoute('/locations/')({
  loader: async () => {
    try {
      const response = await locationApi.getAllStates()
      // locationApi now returns properly transformed Location[] with camelCase properties
      const locations = response.map((loc) => ({
        id: loc.slug || loc.id,
        name: loc.name,
        state: loc.name, // State name is the location name for states
        count: loc.listingCount || 0,
        description: `Browse listings in ${loc.name}`,
      }))
      return { locations }
    } catch (error) {
      console.error('Failed to load locations:', error)
      return { locations: [] }
    }
  },

  pendingComponent: () => (
    <div className="flex items-center justify-center py-20">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-gray-600">Loading locations...</p>
      </div>
    </div>
  ),

  errorComponent: ({ error }) => (
    <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
      <h2 className="text-red-800 font-bold text-xl mb-2">
        Failed to Load Locations
      </h2>
      <p className="text-red-600 mb-4">{error.message}</p>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
      >
        Retry
      </button>
    </div>
  ),

  component: LocationsPage,
})

function LocationsPage() {
  const data = Route.useLoaderData()

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">Browse by Location</h1>
        <p className="text-gray-600">
          Find listings in {data.locations.length} major cities across Nigeria
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {data.locations.map((location) => (
          <Link
            key={location.id}
            to="/locations/$locationId/{-$sublocationId}"
            params={{ locationId: location.id }}
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow"
          >
            <div className="mb-4 text-center">
              <div className="text-5xl mb-2">📍</div>
              <h3 className="text-xl font-bold mb-1">{location.name}</h3>
              <p className="text-gray-600 text-sm">{location.state}</p>
            </div>
            <p className="text-gray-600 text-sm mb-3">{location.description}</p>
            <p className="text-blue-600 font-semibold text-center">
              {location.count.toLocaleString()} listings
            </p>
          </Link>
        ))}
      </div>
    </div>
  )
}
